import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enabler"
export default class extends Controller {
  static targets = [ "enablee" ]
  static values = {
    enableOn: { type: String, default: 'only set if enableType is String' },
    enableOnType: { type: String, default: 'String' }
  }
  
  enable(event) {
    if (!this.isEnabled() && this.canEnable(event.target)) {
      this.doEnable()
    } else {
      this.disable()
    }
  }

  isEnabled() {
    return !this.enableeTarget.disabled
  }

  canEnable(element) {
    if (this.enableOnTypeValue === 'String') {
      return element.value === this.enableOnValue
    } else if (this.enableOnTypeValue === 'Checkbox') {
      return element.checked
    }
    return false
  }

  doEnable() {
    this.enableeTarget.disabled = false
  }

  disable() {
    this.enableeTarget.disabled = true
  }
}
